import {AppRoute} from '../models/AppRoute';

/** A nested navigation target, as `navigate(route, params)` takes it. `params` may nest again. */
export type NestedRouteParams = {screen: AppRoute; params?: Record<string, unknown>};

// EXCLUSIVE_OFFER_DETAIL is a noTabOrDrawerRoutes entry, which the tab navigator (MAIN) registers inside the drawer (ROOT).
export const offerDetailRoute = (offerId: string): [AppRoute, NestedRouteParams] => [
  AppRoute.ROOT,
  {screen: AppRoute.MAIN, params: {screen: AppRoute.EXCLUSIVE_OFFER_DETAIL, params: {offerId}}},
];
